import {Box, Text, Image, SimpleGrid, Flex, ActionIcon} from "@mantine/core";
import {IconPlus} from "@tabler/icons-react";
import {decode} from "html-entities";

export default function _ProductByCategory2({component}) {
    return (
        <Box
            mx={component?.customize_styles?.general_decoration?.margin_x}
            my={component?.customize_styles?.general_decoration?.margin_y}
            px={component?.customize_styles?.general_decoration?.padding_x}
            py={component?.customize_styles?.general_decoration?.padding_y}
            bg={component?.customize_styles?.general_decoration?.background_color}
            bd={`${component?.customize_styles?.general_decoration?.border_width} solid ${component?.customize_styles?.general_decoration?.border_color}`}
            style={{
                borderRadius:`${component?.customize_styles?.general_decoration?.border_radius}px`,
                boxShadow: `${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px #00000014`,
            }}
        >
            <Text>{component?.customize_properties?.label}</Text>

            <SimpleGrid
                cols={component?.customize_styles?.grid_view_decoration?.column}
                spacing={component?.customize_styles?.grid_view_decoration?.row_gap}
                verticalSpacing={component?.customize_styles?.grid_view_decoration?.column_gap}
                mx={component?.customize_styles?.box_decoration?.margin_x}
                my={component?.customize_styles?.box_decoration?.margin_y}
            >
                {component?.items?.map((item) => (
                    <Box
                        key={item?.name}
                        px={component?.customize_styles?.box_decoration?.padding_x}
                        py={component?.customize_styles?.box_decoration?.padding_y}
                        bg={component?.customize_styles?.box_decoration?.background_color}
                        bd={`${component?.customize_styles?.box_decoration?.border_width} solid ${component?.customize_styles?.box_decoration?.border_color}`}
                        style={{
                            borderRadius:`${component?.customize_styles?.box_decoration?.border_radius}px`,
                            boxShadow: `${component?.customize_styles?.box_decoration?.shadow_offset_x}px ${component?.customize_styles?.box_decoration?.shadow_offset_y}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px ${component?.customize_styles?.box_decoration?.shadow_blur_radius}px #00000014`,
                        }}
                    >
                        <Text
                            lineClamp={1}
                            mb={14}
                            fs={component?.customize_styles?.name_text_decoration?.font_style}
                            fw={component?.customize_styles?.name_text_decoration?.font_weight}
                            ff={component?.customize_styles?.name_text_decoration?.font_family}
                            c={component?.customize_styles?.name_text_decoration?.color}
                            lh={component?.customize_styles?.name_text_decoration?.text_height}
                            fz={component?.customize_styles?.name_text_decoration?.font_size}
                            ls={component?.customize_styles?.name_text_decoration?.letter_spacing}
                        >
                            {item?.name}
                        </Text>
                        <Box
                            pos="relative"
                            mb={6}
                            ta={component?.customize_styles?.image_decoration?.alignment}
                        >
                            <Image
                                src={item?.image_url}
                                alt={item?.name}
                                radius={component?.customize_styles?.image_decoration?.radius}
                                fit={component?.customize_styles?.image_decoration?.boxfit}
                                w={component?.customize_styles?.image_decoration?.width}
                                height={component?.customize_styles?.image_decoration?.height}
                                display="inline-block"
                                maw={130}
                                bd="1px solid #cfcfcf"
                            />
                        </Box>

                        <Flex justify="space-between" align="center">
                            <Box>
                                <Text
                                    mb={4}
                                    fs={
                                        component?.customize_styles
                                            ?.product_discount_text_decoration?.font_style
                                    }
                                    fw={
                                        component?.customize_styles
                                            ?.product_discount_text_decoration?.font_weight
                                    }
                                    ff={
                                        component?.customize_styles
                                            ?.product_discount_text_decoration?.font_family
                                    }
                                    c={
                                        component?.customize_styles
                                            ?.product_discount_text_decoration?.color
                                    }
                                    ta={
                                        component?.customize_styles
                                            ?.product_discount_text_decoration?.text_align
                                    }
                                    lh={
                                        component?.customize_styles
                                            ?.product_discount_text_decoration?.text_height
                                    }
                                    fz={
                                        component?.customize_styles
                                            ?.product_discount_text_decoration?.font_size
                                    }
                                    ls={
                                        component?.customize_styles
                                            ?.product_discount_text_decoration?.letter_spacing
                                    }
                                    td="line-through"
                                >
                                    {item?.price}
                                </Text>
                                <Text
                                    fs={
                                        component?.customize_styles?.product_price_text_decoration
                                            ?.font_style
                                    }
                                    fw={
                                        component?.customize_styles?.product_price_text_decoration
                                            ?.font_weight
                                    }
                                    ff={
                                        component?.customize_styles?.product_price_text_decoration
                                            ?.font_family
                                    }
                                    c={
                                        component?.customize_styles?.product_price_text_decoration
                                            ?.color
                                    }
                                    ta={
                                        component?.customize_styles?.product_price_text_decoration
                                            ?.text_align
                                    }
                                    lh={
                                        component?.customize_styles?.product_price_text_decoration
                                            ?.text_height
                                    }
                                    fz={
                                        component?.customize_styles?.product_price_text_decoration
                                            ?.font_size
                                    }
                                    ls={
                                        component?.customize_styles?.product_price_text_decoration
                                            ?.letter_spacing
                                    }
                                    style={{
                                        textDecorationLine:
                                        component?.customize_styles
                                            ?.product_price_text_decoration?.text_decoration,
                                        textDecorationColor:
                                        component?.customize_styles
                                            ?.product_price_text_decoration?.decoration_color,
                                        textDecorationThickness:
                                        component?.customize_styles
                                            ?.product_price_text_decoration
                                            ?.decoration_thickness,
                                    }}
                                >
                                    {decode(item?.currency)} {item?.discount_price ? item.discount_price : item?.price}

                                </Text>
                            </Box>
                            <ActionIcon variant="filled" aria-label="Add" size="lg" color="#00B9D3">
                                <IconPlus style={{ width: "70%", height: "70%" }} stroke={1.5} />
                            </ActionIcon>
                        </Flex>
                    </Box>
                ))}
            </SimpleGrid>
        </Box>
    );
}
